import { Fragment, useState, useEffect } from "react"
import {
  placeholderLogo,
  notFound,
  SearchErrorImage,
  RedAlertImage
} from "../../../images"
import { Input } from "@fourkites/elemental-input"
import BottomBar from "../../BottomBar/bottombar"
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight"
import { useHistory } from "react-router"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "store/store"
import { XIcon } from "@fourkites/elemental-atoms"
import { useDebounce } from "../../../store/hooks"
import { getCompanyIdentifications } from "./StatusTag.types"
import { http } from "utils/http"
import { apiEndPoints } from "constants/apiEndpoints"
import "./GateLinkCarrierSearch.css"
import { useTranslation } from "react-i18next"

const GateLinkCarrierSearch = () => {
  const [loadFoundOnFK, setLoadFoundOnFK] = useState(false)
  const [isCarrierOnFK, setIsCarrierOnFK] = useState(false)
  const [isCarrierContactPresent, setIsCarrierContactPresent] = useState(false)
  const [isCarrierDetailsFetched, setIsCarrierDetailsFetched] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const [disabledProceed, setdisabledProceed] = useState(true)
  const [invalidPhone, setinvalidPhone] = useState(false)
  const [USDOT, setUSDOT] = useState("")
  const [companyName, setcompanyName] = useState("")
  const [query, setQuery] = useState<string>("")
  const [isOutside, setIsOutside] = useState<boolean>(true)
  const assetReducer = useSelector((state: RootState) => state.assetReducer)
  const facilityReducer = useSelector(
    (state: RootState) => state.facilityReducer
  )
  const [suggestions, setSuggestions] = useState<any>([])
  const [selectedSuggestion, setSelectedSuggestion] = useState<any>()
  const [isTryNew, setIsTryNew] = useState<any>()
  const [isCarrierIdentified, setIsCarrierIdentified] = useState<any>()
  const [isSpaceNeeded, setIsSpaceNeeded] = useState(false)
  const [isStartOver, setIsStartOver] = useState<boolean>(false)
  const [isTryAgain, setIstryAgain] = useState<boolean>(false)
  const [tryAgainCount, setTryAgainCount] = useState(0)

  const loadReducer = useSelector(
    (state: RootState) => state.loadDetailsReducer
  )
  const loadDetailsCode = useSelector(
    (state: RootState) => state.loadDetailsReducer.loadDetails?.code
  )

  let permalink = useSelector(
    (state: RootState) => state.loadDetailsReducer.loadDetails?.permalink
  )
  if (permalink === null || permalink == undefined) {
    permalink = "permalink"
  }

  const assetID = useSelector(
    (state: RootState) => state.assetReducer.asset?.id
  )
  const referenceNumber = useSelector(
    (state: RootState) => state.assetReducer.asset?.referenceNumber
  )
  const facilityCode = useSelector(
    (state: RootState) => state.locationReducer?.facilityCode
  )

  function fetchLoadDetails() {
    if (loadDetailsCode === 200) {
      setLoadFoundOnFK(true)
      setCompanyDetails()
    } else if (
      loadDetailsCode === 400 ||
      loadDetailsCode === 404 ||
      loadDetailsCode === 500 ||
      loadDetailsCode === 503
    ) {
      fetchReferenceDetailsAPI()
    }
  }

  function fetchReferenceDetailsAPI() {
    http
      .post(
        `${apiEndPoints.fetchReferenceDetails}`,
        {
          assetID: assetID,
          referenceNumber: referenceNumber,
          useWildCard: true
        },
        {}
      )
      .then(
        response => {
          let details = {
            ...loadReducer.loadDetails,
            code: response.status,
            name: response.data?.referenceDetails?.managingCarrier?.name,
            permalink:
              response.data?.referenceDetails?.managingCarrier?.permalink
          }
          dispatch({
            type: "SET_LOAD_STATUS",
            payload: details
          })
          setCompanyDetails()
          setLoadFoundOnFK(true)
        },
        (error: any) => {
          handleReferenceDetailsError(error)
        }
      )
      .catch(() => true)
  }

  function handleReferenceDetailsError(error: any) {
    let errorCode = error.response?.data?.code
    if (errorCode === 500 || errorCode === 503) {
      setTryAgainCount(tryAgainCount + 1)
      setIstryAgain(true)
    } else if (errorCode === 400 || errorCode === 404) {
      setIstryAgain(false)
      setCompanyDetails()
    }
    if (tryAgainCount === 3) {
      setIsStartOver(true)
    }
  }

  const setCompanyDetails = () => {
    let asset = {
      ...assetReducer.asset,
      usdot: USDOT,
      companyName: companyName
    }

    dispatch({
      type: "SET_ASSET_INFO",
      payload: asset
    })
    http
      .post(
        `${apiEndPoints.fetchCarrierDetails}`,
        {
          facilityId: facilityReducer.facility.id,
          usdot: USDOT,
          permalink: permalink
        },
        {}
      )
      .then(response => {
        const { data } = response.data
        let carrierOnFK = false
        let carrierContactPresent = false

        carrierOnFK = data.isCarrierOnFK
        carrierContactPresent = data.isCarrierContactPresent
        setIsCarrierOnFK(carrierOnFK)
        setIsCarrierContactPresent(carrierContactPresent)
      })
      .then(() => setIsCarrierDetailsFetched(true))
  }

  useEffect(() => {
    if (isCarrierDetailsFetched) {
      handleProceedButton()
    }
  }, [isCarrierDetailsFetched])

  function handleProceedButton() {
    if (!loadFoundOnFK) {
      history.push("/event-tracking")
      return
    } else if (!isCarrierOnFK && isCarrierContactPresent) {
      history.push("/event-tracking")
      return
    } else if (!isCarrierOnFK && !isCarrierContactPresent) {
      history.push({
        pathname: "/dispatch-details",
        state: "/event-tracking"
      })
      return
    } else if (isCarrierOnFK && !isCarrierContactPresent) {
      history.push("/dispatch-details")
      return
    } else if (isCarrierOnFK && isCarrierContactPresent) {
      history.push("/tractor-info")
      return
    }
  }

  useEffect(() => {
    dispatch({
      type: "ENABLE_APP_BAR",
      payload: true
    })
  }, [])

  useEffect(() => {
    let USDOTcode
    let suggestionName = selectedSuggestion ? selectedSuggestion.name : ""
    selectedSuggestion &&
      selectedSuggestion.identifications.map((item: any) => {
        if (item["type"] === "usdot") {
          USDOTcode = item["value"]
          setQuery(suggestionName)
          setcompanyName(suggestionName)
          setUSDOT(USDOTcode)
        }
      })
    if (selectedSuggestion) {
      setIsSpaceNeeded(false)
      dispatch({
        type: "ENABLE_APP_BAR",
        payload: true
      })
    }
  }, [selectedSuggestion])

  useDebounce(
    () => {
      if (!query || query?.length < 3) {
        setSelectedSuggestion(
          null
        ) /** resetting the sugguestion array . so I can't save the previous stored data */
        setSuggestions([])
        if (selectedSuggestion) {
          setdisabledProceed(true)
        }
        return
      }

      let facilityId = facilityReducer.facility.id
      if (!selectedSuggestion) {
        http
          .post(
            `${apiEndPoints.searchCarrier}`,
            {
              facilityId: facilityId,
              search: query,
              permalink: permalink
            },
            {}
          )
          .then(response => {
            const { data } = response.data

            dispatch({
              type: "SET_CARRIER_SEARCH",
              payload: data
            })
            setSuggestions(data.carrierDetails.slice(0, 4))
            if (data.carrierDetails.length === 0) {
              setIsTryNew(true)
              setIsCarrierIdentified(false)
            } else {
              setIsTryNew(false)
              setIsCarrierIdentified(true)
            }
          })
          .catch(err => {
            setIsTryNew(true)
            setIsCarrierIdentified(false)
          })
      }

      if (selectedSuggestion) {
        setdisabledProceed(false)
      }
    },
    500,
    [query]
  )

  const onInputChange = (e: any) => {
    setQuery(e.target.value)
    setIsOutside(false)
  }

  const tryAnotherWay = () => {
    dispatch({
      type: "ENABLE_APP_BAR",
      payload: true
    })

    history.push("/carrier-info")
  }

  const onInputFocus = () => {
    dispatch({
      type: "ENABLE_APP_BAR",
      payload: false
    })

    setIsSpaceNeeded(true)
  }

  const onInputBlur = (e: any) => {
    if (e.target.value.trim().length < 3) {
      setIsSpaceNeeded(false)
      dispatch({
        type: "ENABLE_APP_BAR",
        payload: true
      })
    }
  }

  const suggestionComponents = suggestions?.map((d: any, idx: number) => (
    <Fragment key={idx}>
      <SuggestionSummary
        data={d}
        onSelectSuggestion={query}
        setIsOutside={setIsOutside}
        setSelectedSuggestion={setSelectedSuggestion}
      />
    </Fragment>
  ))
  const { t } = useTranslation()
  const search_carrier_or_usdot = t("search_carrier_or_usdot")
  return (
    <>
      <div
        className={!isSpaceNeeded ? "container" : "container container-search"}
      >
        {!isSpaceNeeded && (
          <div
            className={
              !isSpaceNeeded
                ? "carrier-search"
                : "carrier-search carrier-search-nopadding"
            }
          >
            <div className="carrier-search-noheight">
              <div
                className={
                  !isSpaceNeeded
                    ? "carrier-title"
                    : "carrier-title carrier-title-search"
                }
              >
                {t("add_carrier_details")}
              </div>
            </div>
          </div>
        )}
        <div
          className={` carrier-search carrier-search-USDOT-font carrier-search-noMargintop ${
            invalidPhone ? "error-label" : ""
          }`}
        >
          <div className="carrier-search-height">
            <Input
              label={!isSpaceNeeded ? search_carrier_or_usdot : ""}
              placeholder={t("enter_carrier_name_or_usdot")}
              value={query}
              onChange={onInputChange}
              onFocus={onInputFocus}
              onBlur={onInputBlur}
              icon={query ? <XIcon /> : <></>}
              onIconClick={() => {
                setQuery("")
                setdisabledProceed(true)
                setSelectedSuggestion(null)
                setIsOutside(true)
              }}
              size="large"
            />

            {query && !isOutside && (
              <div
                id="carrier-search-suggestions"
                className="carrier-search-suggestions"
              >
                {suggestionComponents}

                {isTryNew &&
                  query &&
                  query.length > 2 &&
                  suggestionComponents.length === 0 && (
                    <SugesstionsNotFound
                      query={query}
                      onSelectNotFound={true}
                      isOnboarding={false}
                    />
                  )}
              </div>
            )}
          </div>
        </div>
        <div className="network_search_error">
          {isTryAgain && <NetworkError needStartOver={isStartOver} />}
        </div>
      </div>
      {
        <div>
          {isTryNew && query ? (
            <BottomBar
              zIndex="15"
              onClick={() => tryAnotherWay()}
              text={t("try_another_way")}
              endIcon={<KeyboardArrowRightIcon />}
            />
          ) : (
            !isSpaceNeeded && (
              <BottomBar
                disabled={disabledProceed}
                onClick={() => fetchLoadDetails()}
                text={t("save_and_proceed")}
                endIcon={<KeyboardArrowRightIcon />}
              />
            )
          )}
          {isTryAgain && (
            <BottomBar
              zIndex="15"
              onClick={() => fetchReferenceDetailsAPI()}
              text={t("try_again")}
              endIcon={<KeyboardArrowRightIcon />}
            />
          )}
          {isStartOver && (
            <BottomBar
              zIndex="15"
              onClick={() => history.push(facilityCode)}
              text={t("start_over")}
              endIcon={<KeyboardArrowRightIcon />}
            />
          )}
        </div>
      }
    </>
  )
}

const SuggestionSummary = ({
  data,
  onSelectSuggestion,
  setIsOutside,
  setSelectedSuggestion
}: any) => {
  const networkStatus: string = data?.status?.network
  const isConnected = networkStatus === "connected"
  const isPending = ["pending", "invited"].includes(networkStatus)

  const shouldDisableSelection = isConnected || isPending
  const suggestionContainerClass = "carrier-search-suggestionContainer"

  return (
    <div
      className={suggestionContainerClass}
      onClick={() => {
        setSelectedSuggestion(data)
        setIsOutside(true)
      }}
    >
      <CompanySummary data={data} />
    </div>
  )
}

const CompanySummary = ({ data }: any) => {
  const networkStatus: string = data?.status?.network
  const isConnected = networkStatus === "connected"
  const isPending = ["pending", "invited"].includes(networkStatus)

  const shouldDisableSelection = isConnected || isPending

  return (
    <div
      className={"carrier-search-containerCls"}
      id="company-summary-container"
      data-test-id="company-summary-container"
    >
      <img
        className="carrier-search-logo"
        src={data?.logo ? data?.logo : placeholderLogo}
        alt="Company logo"
      />

      <div className="carrier-search-content">
        <div id={"carrier-search-company-name"}>
          <h5 className="carrier-search-title ">{data?.name}</h5>
        </div>
        <div id={"carrier-search-company-ids"}>{`${getCompanyIdentifications(
          data
        )}`}</div>
      </div>
    </div>
  )
}

const SugesstionsNotFound = ({
  onSelectNotFound,
  query,
  isOnboarding
}: any) => {
  const hasNotFoundOption = onSelectNotFound != null
  const { t } = useTranslation()
  const helpText = hasNotFoundOption ? (
    <>
      {t("match_not_found")}
      <br />
      {t("match_not_found_suggestion_text")}
    </>
  ) : (
    ""
  )

  return (
    <div className="carrier-search-notFoundContainer">
      <div className="carrier-search-title center">
        <div>
          {" "}
          <img className="notfoundLogo" src={notFound} />
        </div>
        <span id="carrier-search-title">{`${t(
          "seems_we_cant_find"
        )} "${query}" `}</span>
        <span>{helpText}</span>
      </div>
    </div>
  )
}
const NetworkError = ({ needStartOver }: any) => {
  const { t } = useTranslation()
  const networkErrorText = needStartOver ? (
    <>{t("start_over_message")}</>
  ) : (
    <>{t("try_again_message")}</>
  )
  return (
    <div className="network_error_container">
      <div className="search_error_image">
        <img src={SearchErrorImage} />
      </div>
      <div className="network_error_conatiner_message">
        <img className="notification_error_image" src={RedAlertImage} />
        <div className="network_error">
          <div className="network_error_title">{t("network_error")}</div>
          <div className="network_error_text">{networkErrorText}</div>
        </div>
      </div>
    </div>
  )
}
export default GateLinkCarrierSearch
